import { OfBaseApiTransport } from '@ofs-vuex-crud';
import config from '@/config';

const providerInstance = new OfBaseApiTransport({ apiBase: config.filesApiBase });

export default providerInstance;
